import React, { useState, useEffect } from "react";
import { Title, Stack, Text, Button, Flex } from "@mantine/core";
import colorsCustom from "../designTokens/colorsCustom";
import { useTranslation } from "react-i18next";
import { IconThreads } from "../assets/icon/metric/IconThreads";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";
import { ActionIcon } from "@mantine/core";
import { IconShare } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { useLocation } from "react-router-dom";

const CollectionThreadContent = ({
	selectedThread,
	isMobile,
	setSelectedThread,
	threadList,
	collectionID,
}) => {
	const { t } = useTranslation();
	const location = useLocation();
	const [currentIndex, setCurrentIndex] = useState(
		threadList?.indexOf(selectedThread)
	);

	const [urlSentence, setUrlSentence] = useState("");

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const sentence = params.get('sentence');
		console.log(sentence);
		if (sentence) {
			setUrlSentence(sentence);
		}
	}, []);

	const handleNext = () => {
		const nextIndex = (currentIndex + 1) % threadList.length;
		setCurrentIndex(nextIndex);
		setSelectedThread(threadList[nextIndex]);
	};

	const handlePrev = () => {
		const prevIndex =
			(currentIndex - 1 + threadList.length) % threadList.length;
		setCurrentIndex(prevIndex);
		setSelectedThread(threadList[prevIndex]);
	};

	const highlightSentence = (text, sentence) => {
		if (!sentence) return text;
		const highlightedText = text.replace(
			sentence,
			`<span style="background-color: yellow;">${sentence}</span>`
		);
		return highlightedText;
	};

	return (
		<Stack
			gap={8}
			w={isMobile ? "100%" : "60%"}
			p={isMobile ? "24px" : "0 48px"}
			style={{
				borderLeft: isMobile
					? "none"
					: `1px solid ${colorsCustom.ui.dark.subtle}`,
			}}
		>
			<Title
				order={isMobile ? 4 : 2}
				fw={900}
				ff={'"source-han-serif-korean", serif'}
				c={colorsCustom.ui.dark.bold}
				style={{
					display: "block",
					WebkitLineClamp: 1,
					WebkitBoxOrient: "vertical",
					overflow: "hidden",
					lineHeight: "2rem",
					maxHeight: "2rem",
					whiteSpace: "pre-wrap",
				}}
				mb={isMobile ? 24 : 64}
			>
				{selectedThread.text.split(".")[0].replace(/�/g, "")}
			</Title>
			<Text
				// ff={'"source-han-serif-korean", serif'}
				lh={1.8}
				size={isMobile ? "lg" : "22px"}
				c={colorsCustom.ui.dark.bold}
				fw={500}
				w={isMobile ? "100%" : "calc(100% - 16px)"}
				dangerouslySetInnerHTML={{
					__html: highlightSentence(selectedThread.text, urlSentence),
				}}
			/>
			{!isMobile && (
				<Flex w={"100%"} justify={"space-between"} mt={80}>
					<Button
						w={"50%"}
						component="a"
						target="_blank"
						rel="noreferrer"
						href={selectedThread.permalink}
						color={"inform"}
						fw={600}
						size="lg"
						radius={"xl"}
						leftSection={<IconThreads />}
					>
						{t("myCollection.viewFullThread")}
					</Button>
					<Button
						w={"50%"}
						ml={16}
						color={"inform"}
						variant="outline"
						fw={600}
						size="lg"
						radius={"xl"}
						leftSection={<IconShare />}
						onClick={() => {
							navigator.clipboard.writeText(
								`https://mythreadsinsight.com/collection/${collectionID}`
							);
							notifications.show({
								title: t("myCollection.copied.title"),
								message: `https://mythreadsinsight.com/collection/${collectionID}`,
								color: "blue",
							});
						}}
					>
						{t("myCollection.share")}
					</Button>
				</Flex>
			)}
			{isMobile && (
				<Flex
					justify={"space-between"}
					w={"calc(100%)"}
					align={"center"}
					mt={48}
					p={8}
					style={{
						position: "fixed",
						bottom: 0,
						left: 0,
						right: 0,
						backgroundColor: colorsCustom.paper,
					}}
				>
					<ActionIcon size={"lg"} variant={"subtle"} radius={"xl"} onClick={handlePrev}>
						<IconArrowLeft />
					</ActionIcon>
					<Flex direction={"row"} align={"center"} gap={8}>
						<ActionIcon
							size={"lg"}
							radius={"xl"}
							component="a"
							target="_blank"
							rel="noreferrer"
							color={'inform'}
							href={selectedThread.permalink}
						>
							<IconThreads />
						</ActionIcon>
						<Button
							color={"inform"}
							fw={600}
							variant="outline"
							size="md"
							radius={"xl"}
							style={{
								flex: 1,
							}}
							leftSection={<IconShare />}
							onClick={() => {
								navigator.clipboard.writeText(
									`https://mythreadsinsight.com/collection/${collectionID}`
								);
								notifications.show({
									title: t("myCollection.copied.title"),
									message: `https://mythreadsinsight.com/collection/${collectionID}`,
									color: "blue",
								});
							}}
						>
							{t("myCollection.share")}
						</Button>
					</Flex>
					<ActionIcon size={"lg"} variant={"subtle"} radius={"xl"} onClick={handleNext}>
						<IconArrowRight />
					</ActionIcon>
				</Flex>
			)}
		</Stack>
	);
};

export default CollectionThreadContent;
